module.exports = __webpack_public_path__ + "img/6.dfc204f2.png";